import request from '../../../helpers/request';

export const getRoomAttachment = async (roomId, fileName) => {
  return await request.get(
    `/RentPlace/rental_house/office/${roomId}/attachment`,
    { fileName },
    `При загрузке ${fileName} произошла ошибка`
  );
};
